import axios from 'axios'

const RefreshSingleton = (function () {
  let instance

  function createInstance() {
    return axios
      .create({ withCredentials: true })
      .post('/api/app/v1/security/refresh', {
        refresh_token: localStorage.getItem('refresh_token'),
      })
      .then((response) => {
        const {
          data: { data },
        } = response
        localStorage.setItem('access_token', data.token.access_token)
        localStorage.setItem('refresh_token', data.token.refresh_token)
      })
      .finally(() => (instance = undefined))
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance()
      }
      return instance
    },
  }
})()

export default RefreshSingleton
